import { defineMessages } from 'react-intl';

export default defineMessages({
    returnToPolicyPage: {
        id: 'rewrite.common.views.ml-contact-us.Return to Policy Details page',
        defaultMessage: 'Return to Policy Details page'
    },
    errorNonRetry: {
        id: 'rewrite.common.views.ml-contact-us.non-retry',
        defaultMessage: '<strong>We\'re unable to complete your change online.</strong><br></br> We\'re sorry, we are experiencing technical difficulties with your change. Please contact us by chat or call customer service at <strong> 1-800-255-0332</strong> so we may assist you with completing your change. <br></br> When contacting us, include your policy number <strong> {quoteNumber}</strong> and error code <strong>{errorCode}</strong>.'
    },
    errorNonRetryNoParameters: {
        id: 'rewrite.common.views.ml-contact-us.non-retry-no-parameters',
        defaultMessage: '<strong>We\'re unable to complete your change online.</strong> <br></br> We\'re sorry, we are experiencing technical difficulties with your change. Please contact us by chat or call customer service at <strong> 1-800-255-0332 </strong> so we may assist you with completing your change.'
    }
});